import Vue from 'vue';
import store from './../../store';
import supplierTransformer from './../../transformers/supplier';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const suppliers = supplierTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllSuppliers', suppliers);
  resolve(suppliers);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/suppliers', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/supplier/all.js